var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: true,
        loadProductFromLiquid: false,
        // Placeholder
        showPlaceholderProductList: true,
        placeholderProductPerRow: 6
    },
    selector: {
        products: '#bc-sf-filter-products'
    }
};

/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available; // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Convert images to array
  images = data.images_info;
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  return data;
}
/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/

// UTILS 
var filterUtils = window.theme.utils.filterUtils;

// BCSfFilter.prototype.afterGetFilterData = function(a, b) {
//     if (!this.pageOverFallback(a)) {
//         if (this.hideLoading(),
//         this.removePlaceholderForFilterTree(),
//         ["infinite", "load_more"].indexOf(this.getSettingValue("general.paginationType")) > -1 && this.getSettingValue("general.showLoadMoreLoading") && !1 === this.getSettingValue("general.showLoading") && this.hideLoadMoreLoading(),
//         "collection" == b) {
//             var c = bcsffilter.class.filterOptionOpenList
//               , d = bcsffilter.class.filterOptionCloseList;
//             jQ("." + c).length > 0 && jQ("." + c).remove(),
//             jQ("." + d).length > 0 && jQ("." + d).remove()
//         }
//         a.hasOwnProperty("errorMessage") || (this.catchError(a, b),
//         this.buildAll(a, this.queryParams.build_filter_tree, b))
//     }
// }
/************************** BUILD PRODUCT LIST **************************/
BCSfFilter.prototype.buildProductList = function(a, b) {
    (1 == this.loadProductFirst || "best-selling" == this.defaultSorting || 1 == this.getSettingValue("general.productAndVariantAvailable") || 1 == this.loadProductFirst && (this.queryParams.hasOwnProperty("_") || "collection" == b || "history" == b || "default" != this.getSettingValue("general.paginationType") && "page" == b || this.isSearchPage() || this.isVendorPage() || this.isTagPage())) && (a = this.prepareProductData(a),
    this.buildProductListData(a, b),
    this.buildExtrasProductList(a, b))
}
// BCSfFilter.prototype.buildProductList = function(a, b) {
//     (
//       0 == this.loadProductFirst || 
//       this.isSearchPage() || 
//       this.isVendorPage() || 
//       this.isTagPage() || 
//       this.isTypePage() || "best-selling" == this.defaultSorting || 
//       1 == this.getSettingValue("general.productAndVariantAvailable") || 
//       1 == this.loadProductFirst && 
//       ("init" != b || window.location.search.length > 0) || 
//       1 == this.getSettingValue("general.sortingAvailableFirst")) 
//     && (a = this.prepareProductData(a),
//     this.getSettingValue("general.loadProductFromLiquid") ? 
//     this.buildProductListDataFromLiquid(a, b) : 
//     (this.buildProductListData(a, b),
//     this.buildExtrasProductList(a, b)))
// }
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  
  /* HIDE ITEM : Hide if tag "hide_from_catalog" found basically 
  INFO:
      If item has tag "hide_from_catalog", skip it as its a Gift w/ Purchase item
      We can't set item unavailable on sales channels if its a gift item, so this 
      is solution for now to hide the item from store "all products catalogs"

  RESULTS COUNT NOTE : 
      Page counts will be off by however hidden items there are, but since
      hidden items should have no collection tag assignments, it should only
      affect the "all products" collection and a num or two off shouldn't matter there.
  * --------------------------------------------------------------------------------------- */
  if ( data.tags ) {
    var hasHideFlag = data.tags.filter(function (tag) {
      return tag === 'hide_from_catalog'
    }).length;

    if ( hasHideFlag ) {
      return '';
    }
  }
  
  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Grid Width class
  itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
  // Add Price
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);

  // Add data json
    itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data.json));

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

  // Add Persistent Note
  itemHtml = itemHtml.replace(/{{itemPersistentNote}}/g, buildPersistentNote(data));

    // Add Final Sale
    itemHtml = itemHtml.replace(/{{itemFinalSale}}/g, buildFinalSale(data));

  // SWATCHES : Build data object for usage in react-swatches
  itemHtml = itemHtml.replace(/{{itemSwatch}}/g, buildSwatchItems(data, this));
  return itemHtml;
};
// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
  // For List View
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/
  // Get Template
  var itemHtml = bcSfFilterTemplate.productListItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  // Add Price
  var itemPriceHtml = buildPrice(data, onSale, priceVaries);
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
  // Description
  var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
  itemDescription = (itemDescription.split(" ")).length > 40 ? itemDescription.split(" ").splice(0, 40).join(" ") + '...' : itemDescription.split(" ").splice(0, 40).join(" ");
  itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
  // Add main attribute
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  return itemHtml;
  // End For List View
};
/************************** END BUILD PRODUCT LIST **************************/
/************************** BUILD PRODUCT ITEM ELEMENTS **************************/

// Build Persistent Note HTML
function buildPersistentNote(data) {
  var itemPersistentNoteHtml = '';
  var message = '';
  var highlight = false;
  var highlightColor = '';

  // Check if persistent note exists, and pulls related note data
  function hasPersistentNoteTag() {
    if ( data.tags ) {
      var findTag = function(searchString) {
        var foundTags = data.tags.filter( function( tag ) {
          return tag.indexOf( searchString ) >= 0;
        });

        return foundTags || [];
      };

      // POPULATE : Build array of tags with only the ones we want
      var noteTags = findTag( 'persistent_note_' );
      if ( noteTags.length > 0 ) {

        for (var index in noteTags) {
          if (noteTags.hasOwnProperty(index)) {

            // Check For Highlight Tags
            if ( noteTags[index].indexOf('persistent_note_highlight') !== -1 ) {
              highlight = true;

              // Check for optional hex color highlight option
              var highlightColorString = noteTags[index].replace('persistent_note_highlight_','');

              // Hex Code Checker
              if (/^[0-9A-F]{6}$/i.test(highlightColorString)) {
                highlightColor = highlightColorString;
              }


            // Message Tag
            } else {
              // remove tag prefix
              message = noteTags[index].replace('persistent_note_','');
              // change pipe symbol HTML break
              message = message.replace('|','<br>');
            }

          }
        }

        return true;
      }

      return false;
    }
  }

  if (bcSfFilterConfig.custom.persistent_note_plp_enable && hasPersistentNoteTag() ) {
    var highlightClass = '';
    var highlightColorStyle = '';

    if (highlight) {
      highlightClass = 'highlight';
    }
    if (highlightColor) {
      highlightColorStyle = 'style="color:#' + highlightColor + '"';
    }
    itemPersistentNoteHtml = '<div class="persistent-note-plp ' + highlightClass + '" ' + highlightColorStyle + '>' + message + '</div>';
  }

  return itemPersistentNoteHtml;
}


// Build Final Sale HTML
function buildFinalSale(data) {
  var itemFinalSaleHtml = '';

  // Checks if final sale exists
  function hasFinalSaleTag() {
    if ( data.tags ) {
      var findTag = function(searchString) {
        var foundTags = data.tags.filter( function( tag ) {
          return tag.indexOf( searchString ) >= 0;
        });

        return foundTags || [];
      };

      // POPULATE : Build array of tags with only the ones we want
      return findTag( 'final_sale' ).length > 0 ? true : false;
    }
  }

  if (bcSfFilterConfig.custom.final_sale_plp_enable && hasFinalSaleTag() ) {
    itemFinalSaleHtml = '<div class="final-sale-plp">' + bcSfFilterConfig.custom.final_sale_text + '</div>';
  }

  return itemFinalSaleHtml;
}


function buildGridWidthClass() {
  var gridWidthClass = '';
  // On PC
  switch (bcSfFilterConfig.custom.products_per_row) {
    case 2:
      gridWidthClass = 'bc-sf-filter-grid-width-2';
      break;
    case 3:
      gridWidthClass = 'bc-sf-filter-grid-width-3';
      break;
    case 5:
      gridWidthClass = 'bc-sf-filter-grid-width-5';
      break;
    default:
      gridWidthClass = 'bc-sf-filter-grid-width-4';
      break;
  }
  // On Mobile
  switch (bcSfFilterConfig.custom.products_per_row_mobile) {
    case 1:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-1';
      break;
    case 3:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-3';
      break;
    default:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-2';
      break;
  }
  return gridWidthClass;
}

function buildImages(data) {
  var html = '';
  // Build Main Image
  var thumbUrl = images.length > 0 ? bcsffilter.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
  html += '<img id="product-image-' + data.id + '"' +
    ' data-src="' + thumbUrl + '"' +
    ' data-sizes="auto"' +
    ' class="bc-sf-filter-product-item-main-image lazyload lazyload-fade"' +
    ' alt="' + data.title + '" />';
  // Build Image Swap
  if (bcSfFilterConfig.custom.active_image_swap) {
    var flipImageUrl = images.length > 1 ? bcsffilter.optimizeImage(images[1]['src']) : thumbUrl;
    // added common "product-main-img" class for common function "theme.initSwatchHoverEvent" in other.js
    html += '<img ' +
         ' data-src="' + flipImageUrl + '"' +
         ' data-sizes="auto"' +
         ' class="bc-sf-filter-product-item-flip-image product-main-img lazyload lazyload-fade"' +
         ' alt="' + data.title + '" />';
  }
  return html;
}

function buildVendor(data) {
  var html = '';
  if (bcSfFilterConfig.custom.show_vendor) {
    html = bcSfFilterTemplate.vendorHtml;
  }
  return html;
}

function buildPrice(data) {
  var html = '';
  if (bcSfFilterConfig.custom.show_price) {
    html = '<p class="bc-sf-filter-product-item-price">';
    if (onSale) {
      var tempPrice = bcsffilter.formatMoney(data.price_min);
      tempPrice = tempPrice.replace('.00', '');

      var tempSalePrice = bcsffilter.formatMoney(data.compare_at_price_min);
      tempSalePrice = tempSalePrice.replace('.00', '');

      html += '<span class="bc-sf-filter-product-item-sale-price">' + tempPrice + '</span>';
      html += '<s>' + tempSalePrice + '</s> ';
    } else {
      if (priceVaries) {
        html += (bcSfFilterConfig.label_basic.from) + ' ';
      }
      var tempPrice = bcsffilter.formatMoney(data.price_min);
      tempPrice = tempPrice.replace('.00', '');
      html += '<span class="bc-sf-filter-product-item-regular-price">' + tempPrice + '</span>';
    }
    html += '</p>';
  }
  return html;
}

function buildLabels(data) {
  // Build Sold out label
  var soldOutLabel = '';
  if (bcSfFilterConfig.custom.show_sold_out_label && soldOut) {
    soldOutLabel = bcSfFilterTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
  }
  // Build Sale label
  var saleLabel = '';
  if (bcSfFilterConfig.custom.show_sale_label && onSale && !soldOut) {
    saleLabel = bcSfFilterTemplate.saleLabelHtml.replace(/{{style}}/g, '');
  }
  // Build Labels
  return soldOutLabel + saleLabel;
}
// BUILD LABEL PRODUCT WITH TAGS
function buildTagLabels(data, showall) {
  if (showall) {
    var tagLabel = '';
    if (data.tags) {
      for (var i = 0; i < data.tags.length; i++) {
        var tag = data.tags[i];
        if (tag.indexOf("pfs:label") !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
          tagLabel += preTagLabel;
        }
      }
    }
  } else {
    var tagLabel = '';
    if (data.tags) {
      for (var i = data.tags.length - 1; i >= 0; i--) {
        tag = data.tags[i];
        if (tag.indexOf("pfs:label") !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
          tagLabel += preTagLabel;
          break;
        }
      }
    }
  }
  return tagLabel;
}
function buildSwatchItems(data, vm) {
  var itemSwatchHtml = '';
  if ( bcSfFilterConfig.custom.alternate_colors) {

    // UTILS : Store util methods so we can use inside iterators
    var slugify = vm.slugify;
    var optimizeImage = vm.optimizeImage.bind( vm ); //BCSF constructor needs this context to function
    
    // DATA - DEFAULT IMAGE : Parent image that is displayed by default (used by hover states to reset)
    var productImgUrl = images.length > 0 ? optimizeImage(images[0]['src'], '500x') : bcSfFilterConfig.general.no_image_url;

    // SWATCHES - SWATCH DATA : Grab swatch data array from util method
    var swatchData = filterUtils.getSwatchesFromProduct( data, productImgUrl );

    // SWATCHES - TEMPLATE : React -> SwatchParent.js : Render swatches if multiple colors present
    if ( swatchData && swatchData.length > 1 ) {
      var swatchManifest = [];

      // NOTE : REFACTOR TO A FOR EACH AND USE NEW NORMALIED STRUCTURE!
      swatchData.forEach(function (colorObj) {

        // SWATCH IMAGE : Build swatch image, fallback to color setting in case that fails
        var colorName = slugify(colorObj.title).replace(/-/gi, '_'); //Replace slug dash for _ to support photo studio tool format
        var cleanSku = colorObj.sku.split( '-' )[0];
        var swatchFileName = cleanSku + '_' + colorName + '_sw.jpg';
        var swatchImgUrl = bcSfFilterConfig.general.swatch_replace_url.replace('swatch_url_source_do_not_remove.png', swatchFileName.toLowerCase());

        // SWATCH OBJ: Single swatch object for manifest
        var colorValueName = slugify( colorObj.title );
        var swatch = {
          colorDisplayName: colorObj.title,           // NAME : Color Name that user sees in tooltip
          colorValueName: colorValueName,             // NAME : CSS name for color style fallback
          handle: colorObj.handle,                    // HANDLE : So we direct link to this product color
          productId: data.id,                         // ID : Product ID
          productImgUrl: productImgUrl,               // IMAGE : Product image original (for restoring after hover)
          swatchId: data.id + '-' + colorValueName,   // ID : Swatch : Swatch Color Unique ID
          swatchImgUrl: swatchImgUrl,                 // SWATCH : Image url for swatch (fallback = name as color)
          variantImgUrl: colorObj.image               // IMAGE : Product Variant Image for that color option
        };

        // MANIFEST : ADD : Add this swatch to the list
        swatchManifest.push( swatch );
      });


      // POPULATE : Render the react root element for each swatch list
      var swatchManifestString = JSON.stringify( swatchManifest );
      // added common "swatch-box" class for common function "theme.initSwatchHoverEvent" in other.js
      itemSwatchHtml = "<div class='swatch-box react-swatch-list' data-swatches='" + swatchManifestString + "'></div>";
      // BUILD : Spacer : Only 1 color, spacer no longer needed so just remove the component
    } else {
      itemSwatchHtml = "";
    }
  }

  return itemSwatchHtml;
}
/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
/************************** BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }
  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    // if (currentPage - 4 > 0) {
    //   beforeCurrentPageArr.unshift('...');
    // }
    // if (currentPage - 4 >= 0) {
    //   beforeCurrentPageArr.unshift(1);
    // }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    // if (currentPage + 3 < totalPage) {
    //   afterCurrentPageArr.push('...');
    // }
    // if (currentPage + 3 <= totalPage) {
    //   afterCurrentPageArr.push(totalPage);
    // }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    jQ(this.selector.pagination).html(paginationHtml);
  }
};

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


// Build Filter Tree Mobile (Mobile Filter Button)
BCSfFilter.prototype.buildFilterTreeMobileButton = function(a) {
    var b = !1;
    if (a.hasOwnProperty("filter") && a.filter.hasOwnProperty("options") && a.filter.options.length > 0)
        for (var c = a.filter.options, d = 0; d < c.length; d++)
            if (this.checkShowFilterOption(c[d])) {
                b = !0;
                break
            }
    if (b) {
        var e = this.getSelector("filterTreeMobile")
          , f = this.getSelector("filterTreeMobileButton")
          , g = !1
          , h = this.class.mobileButtonOpen
          , i = this.getSettingValue("label.refineMobile");
        jQ(f).hasClass(h) && (g = !0,
        i = this.getSettingValue("label.refineMobileCollapse"));
        var j = this.getTemplate("filterTreeMobileButton").replace(/{{label}}/g, i);
        jQ(e).html(j),
        g && jQ(f).addClass(h),
        this.buildFilterTreeMobileButtonEvent();

        try {
          var filterSort = bcSfFilterConfig.label.refine_mobile;

          // grabbed from snippets/filter-icon.liquid
          var icon = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill="#0E1317" fill-rule="evenodd" d="M.857142857 4.04571429L7.71428571 4.04571429 7.79142857 4.04571429C8.07814233 5.1897156 9.10633149 5.99201593 10.2857143 5.99201593 11.4650971 5.99201593 12.4932862 5.1897156 12.78 4.04571429L12.8571429 4.04571429 16.2857143 4.04571429C16.7591012 4.04571429 17.1428571 3.66195836 17.1428571 3.18857143 17.1428571 2.7151845 16.7591012 2.33142857 16.2857143 2.33142857L12.8571429 2.33142857C12.7802157 2.32326966 12.7026414 2.32326966 12.6257143 2.33142857 12.2079778 1.41456258 11.2932593.826135497 10.2857143.826135497 9.27816924.826135497 8.36345077 1.41456258 7.94571429 2.33142857 7.86878716 2.32326966 7.79121284 2.32326966 7.71428571 2.33142857L.857142857 2.33142857C.383755929 2.33142857 0 2.7151845 0 3.18857143 0 3.66195836.383755929 4.04571429.857142857 4.04571429zM10.2857143 2.57142857C10.7591012 2.57142857 11.1428571 2.9551845 11.1428571 3.42857143 11.1428571 3.90195836 10.7591012 4.28571429 10.2857143 4.28571429 9.81232736 4.28571429 9.42857143 3.90195836 9.42857143 3.42857143 9.42857143 2.9551845 9.81232736 2.57142857 10.2857143 2.57142857zM.857142857 10.0457143L2.57142857 10.0457143 2.64857143 10.0457143C2.94139926 11.1814747 3.9656691 11.9751577 5.13857143 11.9751577 6.31147376 11.9751577 7.3357436 11.1814747 7.62857143 10.0457143L16.2857143 10.0457143C16.7591012 10.0457143 17.1428571 9.66195836 17.1428571 9.18857143 17.1428571 8.7151845 16.7591012 8.33142857 16.2857143 8.33142857L7.45714286 8.33142857C7.03323308 7.4296234 6.1264698 6.85391545 5.13 6.85391545 4.1335302 6.85391545 3.22676692 7.4296234 2.80285714 8.33142857 2.72593001 8.32326966 2.6483557 8.32326966 2.57142857 8.33142857L.857142857 8.33142857C.383755929 8.33142857 0 8.7151845 0 9.18857143 0 9.66195836.383755929 10.0457143.857142857 10.0457143zM5.14285714 8.57142857C5.61624407 8.57142857 6 8.9551845 6 9.42857143 6 9.90195836 5.61624407 10.2857143 5.14285714 10.2857143 4.66947021 10.2857143 4.28571429 9.90195836 4.28571429 9.42857143 4.28571429 8.9551845 4.66947021 8.57142857 5.14285714 8.57142857zM.857142857 16.0457143L8.65714286 16.0457143C8.95583568 17.1734226 9.97626233 17.9587589 11.1428571 17.9587589 12.309452 17.9587589 13.3298786 17.1734226 13.6285714 16.0457143L16.2857143 16.0457143C16.7591012 16.0457143 17.1428571 15.6619584 17.1428571 15.1885714 17.1428571 14.7151845 16.7591012 14.3314286 16.2857143 14.3314286L13.4571429 14.3314286C13.027492 13.4443106 12.1285438 12.8808597 11.1428571 12.8808597 10.1571705 12.8808597 9.25822228 13.4443106 8.82857143 14.3314286L.857142857 14.3314286C.383755929 14.3314286 0 14.7151845 0 15.1885714 0 15.6619584.383755929 16.0457143.857142857 16.0457143zM11.1428571 14.5714286C11.6162441 14.5714286 12 14.9551845 12 15.4285714 12 15.9019584 11.6162441 16.2857143 11.1428571 16.2857143 10.6694702 16.2857143 10.2857143 15.9019584 10.2857143 15.4285714 10.2857143 14.9551845 10.6694702 14.5714286 11.1428571 14.5714286z"/></svg>';

          jQ('#bc-sf-filter-tree-mobile-button').html(filterSort + icon);
        } catch (e) {
          console.error(e);
        }
    }
};


// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');
    var sortingArr = this.getSortingList();
    if (sortingArr) {
      var paramSort = this.queryParams.sort || '';
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        activeClass = '';
        if(paramSort == k) {
          activeClass = 'active';
        }
        sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass+ '">' + sortingArr[k] + '</a></li>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ('.bc-sf-filter-custom-sorting').html(html);
      if(jQ('.bc-sf-filter-custom-sorting').hasClass("bc-sf-filter-sort-active")) {
        jQ('.bc-sf-filter-custom-sorting').toggleClass('bc-sf-filter-sort-active');
      }

      var labelSort = '';
      var defaultFilter = getParameterByName('sort');
      if(defaultFilter && defaultFilter.length > 0 && paramSort.length > 0) {
        var labelHandle = 'sorting_' + paramSort.replace(/\-/g, '_');
        labelSort = bcSfFilterConfig.label[labelHandle];
      } else {
        labelSort = bcSfFilterConfig.label.sorting;
      }

      jQ('.bc-sf-filter-custom-sorting label.sorting-title').text(labelSort);
    }
  }
};

// Build Sorting event
BCSfFilter.prototype.buildSortingEvent = function() {
  var _this = this;
  jQ('.bc-sf-filter-filter-dropdown a').click(function(e){
    e.preventDefault();
    onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).data('sort'));
  });

  jQ(".bc-sf-filter-custom-sorting > label").click(function(){
    if (!jQ('.bc-sf-filter-filter-dropdown').is(':animated')) {
      jQ('.bc-sf-filter-filter-dropdown').toggle().parent().toggleClass('bc-sf-filter-sort-active');
      jQ('#bc-sf-filter-tree').hide();
    }
  });

  jQ(this.getSelector('filterTreeMobileButton')).click(function(){
    jQ('#bc-sf-filter-top-sorting-mobile .bc-sf-filter-filter-dropdown').hide();
  });
};
// For Toolbar - Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
  var itemHtml = '<span>' + bcSfFilterConfig.label.toolbar_viewas + '</span>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  topDisplayTypeSelector.html(itemHtml);
  // Active current display type
  topDisplayTypeSelector.find('.bc-sf-filter-display-item').removeClass('active');
  if (this.queryParams.display == 'list') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
  } else if (this.queryParams.display == 'grid') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
  }
};
// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function() {
  var _this = this;
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  jQ(this.getSelector('topDisplayType') + ' a').click(function(e) {
    e.preventDefault();
    _this.internalClick = true;
    jQ(this).parent().children().removeClass('active');
    jQ(this).addClass('active');
    if (_this.queryParams.display == 'list') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
    } else if (_this.queryParams.display == 'grid') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
    }
    var newUrl = jQ(this).attr('href');
    _this.onChangeData(newUrl, 'display');
  })
};
// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
  if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ(this.selector.topShowLimit).html('');
    var numberList = this.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k = 0; k < arr.length; k++) {
        showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      jQ(this.selector.topShowLimit).html(html);
      // Set value
      jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
    }
  }
};
// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
  if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
    var breadcrumbItemsHtml = '';
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
      var colInfo = colData.collection;
      if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
        breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
      } else {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
      }
    } else {
      breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.getSettingValue('label.defaultCollectionHeader'));
    }
    var html = bcSfFilterTemplate.breadcrumbHtml.replace(/{{breadcrumbItems}}/g, breadcrumbItemsHtml)
    html = html.replace(/{{breadcrumbDivider}}/g, bcSfFilterTemplate.breadcrumbDivider);
    jQ(this.selector.breadcrumb).html(html);
  }
};
/************************** END BUILD TOOLBAR **************************/
function matchHeightImage() {
  jQ('.bc-sf-filter-product-item-main-image').load(function() {
    var imageContainer = jQ(this).parent();
    imageContainer.css('width', '100%');
  }).each(function() {
    if (this.complete) jQ(this).load();
  });
}
// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
    /* start-initialize-bc-al */
    var self = this;
    var alEnable = true;
    if(self.getSettingValue('actionlist.qvEnable') != '' || self.getSettingValue('actionlist.atcEnable') != ''){
      alEnable = self.getSettingValue('actionlist.qvEnable') || self.getSettingValue('actionlist.atcEnable');
    }
    if (alEnable === true && typeof BCActionList !== 'undefined') {
        if (typeof bcActionList === 'undefined') {
            bcActionList = new BCActionList();
        }else{
          if (typeof bcAlParams !== 'undefined' && typeof bcSfFilterParams !== 'undefined') {
              bcActionList.initFlag = false;
              bcActionList.alInit(bcSfFilterParams, bcAlParams);
          } else {
              bcActionList.alInit();
          }
        }
    }

    /* end-initialize-bc-al */
  // Call theme init function
  if (typeof theme !== 'undefined' && typeof theme.init === 'function') {
    $(theme.init);
  }
  // End For List View
};
// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  var _this = this;
  var totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_other + '</span>';
  if (data.total_product == 1) {
    totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_one + '</span>';
  }

  // DATA PREP : Grab initial app pass w/ filter info & store to filterUtils for subsequent manual renders for merge cases
  if ( data.filter && data.filter.options ) {
    filterUtils.updateFilterState({
      filter: data.filter,
      total_product: data.total_product
    });
  }

  jQ('#bc-sf-filter-total-product').html(totalProduct);
  matchHeightImage();
  jQ(window).resize(function() {
    matchHeightImage();
  });

  jQ('body').find('.bc-sf-filter-skeleton-button').remove();

  // Prevent double tap on iOS
  var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (isiOS){
    this.isMobile()&&jQ(".bc-sf-filter-product-item").find("a").on("touchstart",function(){isScrolling=!1}).on("touchmove",function(){isScrolling=!0}).on("touchend",function(){isScrolling||(window.location=jQ(this).attr("href"))});
  }

  // Fix image not loaded on mobile
  (this.isMobile()||null!=navigator.userAgent.match(/iPad/i))&&(setTimeout(function(){jQ(".bc-sf-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},200),setTimeout(function(){jQ(".bc-sf-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},2e3));

  // SWATCHES : Trigger event emit to re-render swatches
  $.event.trigger({
    type: "collectionUpdated",
    time: new Date()
  });

  if (window.SPR) {
    window.SPR.initDomEls();
    window.SPR.loadBadges();
  }
};

/*
* // Author : HaiChen Song
* Since merged products have been getting by promise, the collection page is not working properly.
* So we must modify the buildAll function in bc-sf-filter-lib.js.
* If bc-sf-filter-lib file may be updated in future, please update the following buildAll function by updated lib.
* 
* */

BCSfFilter.prototype.buildProductList = function(a, b) {
    (1 == this.loadProductFirst || "best-selling" == this.defaultSorting || 1 == this.getSettingValue("general.productAndVariantAvailable") || 1 == this.loadProductFirst && (this.queryParams.hasOwnProperty("_") || "collection" == b || "history" == b || "default" != this.getSettingValue("general.paginationType") && "page" == b || this.isSearchPage() || this.isVendorPage() || this.isTagPage())) && (a = this.prepareProductData(a),
    this.buildProductListData(a, b),
    this.buildExtrasProductList(a, b))
}

function buildAllProcess(a, b, c, d, e, f) {
  bcsffilter.buildProductList(a.products, c);
  "default" == bcsffilter.getSettingValue("general.paginationType") ? bcsffilter.buildPagination(f) : (jQ(e).empty(), d.isLoadMorePaginationType() && (bcsffilter.buildLoadMoreButton(f), bcsffilter.buildLoadPreviousButton(f, c))), bcsffilter.buildToolbar(), bcsffilter.buildToolbarEvent(a), jQ(bcsffilter.selector.filterWrapper).show();
  var g = bcsffilter.selector.topNotification;
  jQ(g).length > 0 && jQ(g).empty();
  jQ(bcsffilter.selector.products).removeAttr("data-bc-sort"), jQ(e).show(), bcsffilter.buildAdditionalElements(a, c), bcsffilter.buildScrollToTop(), bcsffilter.scrollBackPositionHistoryBack(), "collection" == c && bcsffilter.buildPageInfo(a), bcsffilter.isSearchPage() && (bcsffilter.buildSEOTitle(a), bcsffilter.buildSearchResultHeader(a), bcsffilter.buildSearchResultNumber(a)), bcsffilter.buildRobotsMetaTag(a), bcsffilter.selectFilter = !1
}

BCSfFilter.prototype.buildAll = function(a, b, c) {
  var d = bcsffilter,
    e = bcsffilter.selector.pagination,
    f = a.total_product;
  if (!0 === b && a.hasOwnProperty("filter") && (bcsffilter.buildFilterTree(a.filter.options), bcsffilter.getSettingValue("general.showRefineBy") && bcsffilter.buildFilterSelection(a), bcsffilter.buildFilterTreeMobile(), this.buildFilterTreeMobileButton(a), this.buildAdditionalFilterEvent()), f > 0) {
    filterUtils.prepareProductData(a.products).then(function (mergedProducts) {
      a.products = mergedProducts;
      buildAllProcess(a, b, c, d, e, f);
    }, function (error) {
      console.log('Error on bc-sf-filter.js buildAll:', error);
      buildAllProcess(a, b, c, d, e, f);
    });
  } else {
    jQ(bcsffilter.selector.products).removeAttr("data-bc-sort"), jQ(e).show(), bcsffilter.buildAdditionalElements(a, c), bcsffilter.buildScrollToTop(), bcsffilter.scrollBackPositionHistoryBack(), "collection" == c && bcsffilter.buildPageInfo(a), bcsffilter.isSearchPage() && (bcsffilter.buildSEOTitle(a), bcsffilter.buildSearchResultHeader(a), bcsffilter.buildSearchResultNumber(a)), bcsffilter.buildRobotsMetaTag(a), bcsffilter.selectFilter = !1
  }
};

// fix swatch color filter list
BCSfFilter.prototype.buildFilterOptionSwatchData = function(a, b, c, d, e, f, g) {
  if (this.checkShowFilterOptionItem(f, g)) {
    var h = f.key,
      i = f.key,
      j = i;
    "collection" == a && (h = f.label, i = f.handle, j = h);
    var k = this.getSettingValue("general.colorOptionsArr"),
      l = b.replace("pf_t_", "").replace("pf_opt_", "");
    
    if ("" != k) {
      void 0 !== k.filter(function(a) {
        return b.indexOf(a) > -1
      })[0] && (l = "color")
    }
    
    j = this.customizeSwatchFileName(j, f, g);
    var m = this.getTemplate("filterOptionSwatchItem");
    m = this.buildFilterOptionItem(m, h, i, a, b, c, d, e, f, g);
    var n = getFilePath(l + "-" + j, this.swatchExtension, this.getSettingValue("general.swatchImageVersion"));
    n = n.replace(/swatch_url_source_do_not_remove.png/g, '');
    m = m.replace(/{{itemImageValue}}/g, n);
    var o = g.hasOwnProperty("borderSwatch") && "" != g.borderSwatch ? g.borderSwatch : "none";
    
    return m = m.replace(/{{itemBorder}}/g, o);
  }
  return '';
};


// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};


BCSfFilter.prototype.prepareProductData = function(data) {
  var countData = data.length;
  for (var k = 0; k < countData; k++) {
    data[k]['imgArr'] = data[k]['images'];
    data[k]['images'] = data[k]['images_info'];
    if (data[k]['images'].length > 0) {
      data[k]['featured_image'] = data[k]['images'][0]
    } else {
      data[k]['featured_image'] = {
        src: bcSfFilterConfig.general.no_image_url,
        width: '',
        height: '',
        aspect_ratio: 0
      }
    }
    data[k]['url'] = '/products/' + data[k].handle;
    var optionsArr = [];
    var countOptionsWithValues = data[k]['options_with_values'].length;
    for (var i = 0; i < countOptionsWithValues; i++) {
      optionsArr.push(data[k]['options_with_values'][i]['name'])
    }
    data[k]['options'] = optionsArr;

    if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {
      var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase()
        .trim();

      function updateMultiCurrencyPrice(oldPrice, newPrice) {
        if (typeof newPrice != 'undefined') {
          return newPrice;
        }
        return oldPrice;
      }
      data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);
      data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);
      data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);
      data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);
      data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;
    }

    data[k]['price'] = data[k]['price_min'];
    data[k]['compare_at_price'] = data[k]['compare_at_price_min'];
    data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];

    var firstVariant = data[k]['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
      var paramVariant = data[k]['variants'].filter(function(e) {
        return e.id == getParam('variant')
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]
    } else {
      var countVariants = data[k]['variants'].length;
      for (var i = 0; i < countVariants; i++) {
        if (data[k]['variants'][i].available) {
          firstVariant = data[k]['variants'][i];
          break
        }
      }
    }
    data[k]['selected_or_first_available_variant'] = firstVariant;
    var countVariants = data[k]['variants'].length;
    for (var i = 0; i < countVariants; i++) {
      var variantOptionArr = [];
      var count = 1;
      var variant = data[k]['variants'][i];
      var variantOptions = variant['merged_options'];
      if (Array.isArray(variantOptions)) {
        var countVariantOptions = variantOptions.length;
        for (var j = 0; j < countVariantOptions; j++) {
          var temp = variantOptions[j].split(':');
          data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
          data[k]['variants'][i]['option_' + temp[0]] = temp[1];
          variantOptionArr.push(temp[1])
        }
        data[k]['variants'][i]['options'] = variantOptionArr
      }
      data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
      data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100
    }
    data[k]['description'] = data[k]['content'] = data[k]['body_html'];
    if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {
      data[k]['tags'] = data[k]['original_tags'].slice(0);
    }
    data[k]['json'] = customizeJsonProductData(data[k]);
  }
  return data;
};
